import useRolePermission from "entities/auth/hooks/useRolePermission";
import { Page } from "entities/pages/types";
import ConfirmMaintenanceModal from "modules/brands/components/ConfirmMaintenanceModal";
import DeleteModals from "modules/brands/components/DeleteModals";
import MaintenanceModeWarningMessage from "modules/brands/components/MaintenanceModeWarningMessage";
import PageDetails from "modules/brands/components/PageDetails";
import { usePagesPage } from "modules/brands/context";
import { getPagesColumns } from "modules/brands/helpers";
import { FC } from "react";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import DragNDropTable from "shared/components/DragNDropTable";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import SearchField from "shared/components/SearchField";
import { BRAND_SUB_PAGE_PATH } from "shared/routes/paths";

const PagePreview: FC = () => {
  const { id } = useParams();
  const brandId = String(id);
  const {
    isLoadingPages,
    columnsParams,
    mutateReorderPages,
    pageMaintenanceModeModal,
    pageMaintenanceModeDescription,
    isLoadingPageMaintenanceMode,
    handlePageMaintenanceMode,
    searchData,
  } = usePagesPage();
  const navigate = useNavigate();

  const columns = getPagesColumns(columnsParams);
  const writeAccess = useRolePermission("brandsAndPages:write");

  return (
    <FlexColumn marginTop="1rem">
      <FlexCenter
        marginBottom={"1rem"}
        gap="1rem"
        flexDirection="column"
        alignItems="flex-start"
      >
        <SearchField
          placeholder="Search..."
          value={searchData.value}
          onChange={searchData.onChange}
        />
      </FlexCenter>

      <DragNDropTable<Page>
        items={searchData.filteredData || []}
        columns={columns}
        reorderDisabled={!writeAccess.allowed || searchData.isSearchActive}
        isItemsFetched={!isLoadingPages}
        isItemsLoading={isLoadingPages}
        noItemsMessage="No pages found"
        emptyListMessage="No pages found"
        onItemsReorder={async (pages) => {
          mutateReorderPages({
            brandId,
            pages,
          });
        }}
        onRowClick={(params) =>
          navigate(
            generatePath(BRAND_SUB_PAGE_PATH, {
              id: brandId,
              tabId: "pages",
              tabDetailsId: params.id,
            }),
          )
        }
      />
      <PageDetails />
      <DeleteModals />
      <ConfirmMaintenanceModal
        title={`Confirm Brand Maintenance Mode for ${pageMaintenanceModeModal.modalDetails?.title ?? ""}`}
        subtitle="Are you sure you want to enable Maintenance Mode for this page? Users won't be able to access it until it's turned off."
        isOpen={pageMaintenanceModeModal.isOpen}
        warningMessage={<MaintenanceModeWarningMessage />}
        onCancel={pageMaintenanceModeModal.closeModal}
        onConfirm={() =>
          handlePageMaintenanceMode(
            pageMaintenanceModeModal.modalDetails.id,
            true,
          )
        }
        descriptionInput={pageMaintenanceModeDescription}
        isLoading={isLoadingPageMaintenanceMode}
      />
    </FlexColumn>
  );
};

export default PagePreview;
